/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable react/require-default-props */

import React, { FC, useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import Model from '@tripian/model';
import { AccommendationCard, DirectionInfo, FlightCard, RouteResult, Switch, StepTimeframe, PlanChangeDay } from '@tripian/react';

import ICombinedState from '../../../../redux/model/ICombinedState';
// import { /* changeFocusInfoVisible, */ changeLocalExperiencesModalVisible /* , changeSearchVisible */ } from '../../../../redux/action/layout';

import './StepList.scss';
import config from '../../../../config';
import demoData from '../../../../demo/data';

import SortableStepList from '../../../../components/SortableStepList/SortableStepList';
import DefaultStepCard from '../../../../components/DefaultStepCard/DefaultStepCard';

import /* stepReplace, */
/* changeAlternativeStepId, */
/* changeDay, */
// saveError,
/* stepDelete, */
'../../../../redux/action/trip';

import useTrip from '../../../../hooks/useTrip';
import usePlan from '../../../../hooks/usePlan';
import useStep from '../../../../hooks/useStep';
import useReaction from '../../../../hooks/useReaction';
import useAlternative from '../../../../hooks/useAlternative';
import useFocus from '../../../../hooks/useFocus';

const getAccommendationStep = (accommendation: Model.Accommodation): Model.Step => {
  const accommendationPoi: Model.Poi = {
    id: 0,
    name: accommendation.name || 'AccommendationState Name',
    description: accommendation.address || 'AccommendationState Address',
    marker_coordinate: accommendation.coordinate || { lat: 0, lng: 0 },
    //
    city_id: 0,
    image: { url: '', image_owner: { title: '', url: '', avatar: '' }, width: null, height: null },
    gallery: [],
    price: 5,
    rating: 5,
    rating_count: 0,
    web: null,
    phone: null,
    address: null,
    icon: 'Homebase',
    coordinate: accommendation.coordinate || { lat: 0, lng: 0 },
    booking: [],
    category: [],
    tags: [],
    must_tries: [],
    cuisines: null,
    attention: null,
    hours: null,
    closed: [],
    distance: null,
    status: true,
    safety: null,
  };

  const accommendationStep: Model.Step = {
    id: 0,
    poi: accommendationPoi,
    alternatives: [],
    order: -1,
    score: null,
    hours: { from: '', to: '' },
  };

  return accommendationStep;
};

interface IStepList {
  planDayIndex: number;
  changePlanDayIndex: (newPlanDayIndex: number) => void;
  alternativesStepId?: number;
  setAlternativesStepId: (stepId?: number) => void;
  showExplorePlaces: () => void;
  showLocalExperiences: () => void;
}

const StepList: FC<IStepList> = ({ planDayIndex = 0, changePlanDayIndex, alternativesStepId, setAlternativesStepId, showExplorePlaces, showLocalExperiences }) => {
  const [sortStepList, setSortStepList] = useState<boolean>(false);
  const [sortedStepList, setSortedStepList] = useState<Array<number>>([]);
  const [legsOffset, setLegsOffset] = useState<number>(0);

  const { tripReference } = useTrip();
  const { plans, planUpdateOrders, planUpdateTime } = usePlan();
  const { stepReplace, stepDelete } = useStep();
  const { alternatives } = useAlternative();
  const { reactions, reactionAdd, reactionDelete, loadingReactionStep } = useReaction();
  const { focusStep, focusAlternative, focusLost } = useFocus();

  const plan = useMemo(() => (plans ? plans[planDayIndex] : undefined), [planDayIndex, plans]);
  const plansIdDate = useMemo(() => plans?.map((p) => ({ id: p.id, date: p.date })) || [], [plans]);

  const {
    /* accommendation, arrivalDateTime, cityId, plan, */
    /* plans, */ /* alternatives, */
    /* alternativesStepId, */ legs /*  planRefs, */,
    /* day, */
  } = useSelector((state: ICombinedState) => ({
    // accommendation: state.trip.data?.trip_profile.accommodation,
    // arrivalDateTime: state.trip.data?.trip_profile.arrival_datetime,
    // cityId: state.trip.data?.city.id || 0,
    // hash: state.trip.hash, redux state undefined
    // plans: state.trip.data?.plans,
    // // plan: state.trip.data?.plans[state.trip.day],
    // alternatives: state.trip.alternatives,
    /* alternativesStepId: state.trip.alternativesStepId, */
    legs: state.gmap.legs,
    // day: state.trip.day,
    // tripArrivalDatetime: state.trip.data?.trip_profile.arrival_datetime,
    // tripDepartureDatetime: state.trip.data?.trip_profile.departure_datetime,
    // planRefs: state.trip.data?.plans.map((planRef) => ({ id: planRef.id, date: planRef.date })),
  }));

  // const dispatch = useDispatch();

  useEffect(() => {
    if (tripReference?.trip_profile.accommodation) setLegsOffset(1);
    else setLegsOffset(0);
  }, [tripReference]);

  useEffect(() => {
    setSortStepList(false);
    setSortedStepList([]);
  }, [plan]);

  // step current reactions
  const memoizedThumbs = useCallback(
    (step: Model.Step) => {
      let t = 0;
      const stepReaction = reactions?.find((userReaction) => userReaction.step_id === step.id && userReaction.poi_id === step.poi.id);
      if (stepReaction) {
        if (stepReaction.reaction === Model.REACTION.THUMBS_UP) {
          t = 1;
        } else if (stepReaction.reaction === Model.REACTION.THUMBS_DOWN) {
          t = -1;
        } else {
          // eslint-disable-next-line no-console
          console.warn('unknown step reaction', stepReaction.reaction);
        }
      } else {
        // console.log('no step reaction', step.id);
      }
      return t;
    },
    [reactions],
  );

  const memoizedThumbsClicked = useCallback(
    (step: Model.Step, thumbs: number) => {
      const userReactionRequest: Model.UserReactionRequest = {
        step_id: step.id,
        poi_id: step.poi.id,
        reaction: Model.REACTION.THUMBS_UP,
      };
      if (thumbs === -1) userReactionRequest.reaction = Model.REACTION.THUMBS_DOWN;
      reactionAdd(userReactionRequest);
    },
    [reactionAdd],
  );

  const memoizedThumbsUndo = useCallback(
    (step: Model.Step) => {
      const stepUserReaction = reactions?.find((userReaction) => userReaction.step_id === step.id);
      if (stepUserReaction) {
        reactionDelete(stepUserReaction.id, stepUserReaction.step_id);
      } else {
        // eslint-disable-next-line no-console
        console.error(`StepCard.ThumbsUndo called with =${step.id}`);
      }
    },
    [reactions, reactionDelete],
  );

  const emptyPlanMessage = () => {
    let message = 'Add places to your itinerary.';

    if (plans && plan) {
      if (planDayIndex === 0 && plan.generated_status === -1) {
        message = 'No recommendations due to arrival time.';
      } else if (planDayIndex === plans.length - 1 && plans[plans.length - 1].generated_status === -1) {
        message = 'No recommendations due to departure time.';
      }
    }

    return message;
  };

  const alternativeDayNumbers = (alternativePois: Model.Poi[]): number[][] => {
    const getDayNumbers = (poiId: number): number[] => {
      if (poiId < 1) return [];

      const partOfDayNumbers: number[] = [];
      if (plans) {
        for (let i = 0; i < plans.length; i += 1) {
          const stepIndex = plans[i].steps.findIndex((step) => step.poi.id === poiId);
          if (stepIndex > -1) {
            // console.log('alternativeDayNumbers dayNumber', stepIndex + 1);
            partOfDayNumbers.push(i + 1);
          }
        }
        return partOfDayNumbers;
      }
      return [];
    };

    return alternativePois.map((ap) => getDayNumbers(ap.id));
  };

  const windowOpenBookARide = (leg: RouteResult.ILeg) => {
    const bookARideUrl =
      leg.travel.between && leg.travel.between.pickup.coordinate
        ? `https://m.uber.com/?client_id=StrtxTcD7VgyYiUZyXF3-ViEhhkLzhZp&action=setPickup&pickup[latitude]=${leg.travel.between.pickup.coordinate.lat}&pickup[longitude]=${leg.travel.between.pickup.coordinate.lng}&pickup[nickname]=${leg.travel.between.pickup.nickname}&pickup[formatted_address]=${leg.travel.between.pickup.formatted_address}&dropoff[latitude]=${leg.travel.between.dropoff.coordinate.lat}&dropoff[longitude]=${leg.travel.between.dropoff.coordinate.lng}&dropoff[nickname]=${leg.travel.between.dropoff.nickname}&dropoff[formatted_address]=${leg.travel.between.dropoff.formatted_address}`
        : 'https://m.uber.com';
    window.open(bookARideUrl);
  };

  const defaultStepList =
    plan?.steps.length === 0 ? (
      <div className="m10">{emptyPlanMessage()}</div>
    ) : (
      <>
        {tripReference?.trip_profile.accommodation && legs[0] ? (
          <div className="startAccommendation">
            <DirectionInfo
              distance={legs[0].distance.text}
              direction={legs[0].duration.text}
              travel={legs[0].travel}
              bookaride={() => {
                windowOpenBookARide(legs[0]);
              }}
            />
          </div>
        ) : null}
        {plan?.steps
          ?.sort((a, b) => a.order - b.order)
          .map((step, stepIndex) => {
            const stepAltertives = alternatives?.find((a) => a.stepId === step.id);
            const alternativePois = stepAltertives ? stepAltertives.pois : [];

            return (
              <div key={step.id} className="stepListCards">
                <DefaultStepCard
                  key={step.id}
                  step={step}
                  clicked={focusStep}
                  alternativePois={alternativePois}
                  alternativePoisDays={alternativeDayNumbers(alternativePois)}
                  showAlternatives={alternativesStepId === step.id}
                  showAlternativesChange={(stepId, show) => {
                    setAlternativesStepId(show ? stepId : undefined);
                  }}
                  alternativePoiCardClicked={(alternativePoi) => {
                    focusAlternative(step.id, alternativePoi);
                  }}
                  alternativeReplace={(alternativePoi) => {
                    focusLost();
                    stepReplace(step.id, alternativePoi.id);
                  }}
                  thumbs={memoizedThumbs(step)}
                  thumbsClicked={(like) => {
                    memoizedThumbsClicked(step, like);
                  }}
                  thumbsLoading={loadingReactionStep(step.id)}
                  userReactionUndo={() => {
                    memoizedThumbsUndo(step);
                    setAlternativesStepId(undefined);
                  }}
                  userReactionRemoveStep={() => stepDelete(step.id)}
                />
                {legs[stepIndex + legsOffset] ? (
                  <DirectionInfo
                    distance={legs[stepIndex + legsOffset].distance.text}
                    direction={legs[stepIndex + legsOffset].duration.text}
                    travel={legs[stepIndex + legsOffset].travel}
                    bookaride={() => {
                      windowOpenBookARide(legs[stepIndex + legsOffset]);
                    }}
                  />
                ) : null}
              </div>
            );
          })}
      </>
    );

  const sortableStepList = (
    <SortableStepList
      steps={plan?.steps || []}
      callbackSortableStepList={(list) => {
        setSortedStepList(list);
      }}
    />
  );

  const stepList = sortStepList ? sortableStepList : defaultStepList;
  const accommendationMemo = useMemo(() => {
    if (tripReference?.trip_profile.accommodation) {
      const { accommodation } = tripReference.trip_profile;

      return (
        <div className="px2">
          <AccommendationCard
            accommodation={accommodation}
            clicked={() => {
              if (!sortStepList) {
                const accommendationStep = getAccommendationStep(accommodation);
                focusStep(accommendationStep);
              }
            }}
          />
        </div>
      );
    }
    return null;
  }, [tripReference, sortStepList, focusStep]);

  const flightMemo = useMemo(() => {
    if (tripReference) {
      if (config.DEMO && demoData.cityId === tripReference.city.id && tripReference.trip_profile.accommodation && planDayIndex === 0) {
        const { accommodation } = tripReference.trip_profile;

        return (
          <div className="px2">
            <FlightCard
              airportName={demoData.flightCard.airportAccommendationLeg.travel.between?.pickup.nickname || ''}
              arrivalTime={moment(tripReference.trip_profile.arrival_datetime).utcOffset(0).format('HH:mm A')}
              checkinDetail={demoData.flightCard.checkinDetail}
            />
            <DirectionInfo
              distance={demoData.flightCard.airportAccommendationLeg.distance.text}
              direction={demoData.flightCard.airportAccommendationLeg.duration.text}
              travel={{
                text: demoData.flightCard.airportAccommendationLeg.travel.text,
                value: demoData.flightCard.airportAccommendationLeg.travel.value,
              }}
              bookaride={() => {
                const airportAccommendationLeg: RouteResult.ILeg = { ...demoData.flightCard.airportAccommendationLeg };
                if (airportAccommendationLeg.travel.between && accommodation.coordinate && accommodation.name && accommodation.address) {
                  airportAccommendationLeg.travel.between.dropoff.coordinate = accommodation.coordinate;
                  airportAccommendationLeg.travel.between.dropoff.nickname = accommodation.name;
                  airportAccommendationLeg.travel.between.dropoff.formatted_address = accommodation.address;
                }
                windowOpenBookARide(airportAccommendationLeg);
              }}
            />
          </div>
        );
      }
    }

    return null;
  }, [planDayIndex, tripReference]);

  return (
    <div className="stepList scrollable-y">
      <div className="row mt5 mb5">
        {/* DAY SELECT */}
        <div className="col col12 col4-m center" style={{ fontWeight: 600 }}>
          {plansIdDate.length > 0 ? (
            // <div className="row m0 p0">
            //   <div className="col col2 mt1">
            //     <SvgIcons.Calendar />
            //   </div>
            // <div className="col col10">
            <PlanChangeDay options={plansIdDate} defaultIndex={planDayIndex} onDayChange={changePlanDayIndex} />
          ) : // </div>
          // </div>
          null}
        </div>

        {/* EXPLORE PLACES */}
        <div className="col col4 hide-s center">
          <div className="search-tours-button" onClick={showExplorePlaces} onKeyPress={() => {}} role="button" tabIndex={0}>
            <div className="explore-places-icon" />
            <span>Explore Places</span>
          </div>
        </div>

        {/* LOCAL EXPERINCES */}
        <div className="col col4 hide-s center">
          <div className="search-tours-button" onClick={showLocalExperiences} onKeyPress={() => {}} role="button" tabIndex={0}>
            <div className="local-experiences-icon" />
            <span>Local Experiences</span>
          </div>
        </div>
      </div>

      {/* TIMEFRAME */}
      <div className="row mb2">
        <div className="col col10 col6-m mb0 pb0">
          <StepTimeframe
            defaultTimeframe={{ startTime: plan?.start_time || '09:00', endTime: plan?.end_time || '21:00' }}
            callbackStepTimeframe={(timeframe) => {
              if (plan) planUpdateTime(plan.id, timeframe.startTime, timeframe.endTime);
            }}
          />
        </div>

        {/* MANUEL SORT */}
        {plan?.steps.length === 0 ? null : (
          <div className="col col2 col6-m mb0 pb0">
            <div className="switch">
              <Switch
                value={sortStepList}
                onchange={(value) => {
                  setSortStepList(value);
                  if (!value && sortedStepList.length > 0 && plan) planUpdateOrders(plan.id, sortedStepList);
                }}
              />
            </div>
          </div>
        )}
      </div>

      {flightMemo}
      {accommendationMemo}
      {stepList}
      {plan?.steps.length === 0 ? null : accommendationMemo}
    </div>
  );
};

export default StepList;
